module.exports = __webpack_public_path__ + "img/virkistysreitin_lähtöpiste_original.4f93daa1.jpg";